import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Archive, Delete, Edit } from "@mui/icons-material";

import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import KsbActionButton from "../../../../2_ksbHub/components/KsbActionButton";

function EventManagerActions({
  isAnEventManagerAdmin,
  selectedEvent,
  actions,
  dialogs,
}) {
  const { isTeacherView } = useAppContext();
  const theme = useTheme();

  if (!isAnEventManagerAdmin || isTeacherView) return null;

  return (
    <Box
      sx={{
        mt: 1.5,
        display: "flex",
        justifyContent: "flex-end",
        gap: 1,
      }}
    >
      <KsbActionButton
        onClick={() => {
          dialogs.setEditingEvent(selectedEvent); // ✅ set data
          dialogs.setCreateEventOpen(true); // ✅ then open
        }}
        icon={<Edit />}
        label="Event Bearbeiten"
        sx={{ bgcolor: theme.palette.primary.main }}
      />

      <KsbActionButton
        onClick={() => actions.handleArchiveEvent(selectedEvent.id)}
        icon={<Archive />}
        label="Archivieren"
        sx={{ bgcolor: theme.palette.error.light }}
      />

      <KsbActionButton
        onClick={() => actions.handleDeleteEvent(selectedEvent.id)}
        icon={<Delete />}
        label="Löschen"
        sx={{ bgcolor: theme.palette.error.main }}
      />
    </Box>
  );
}

export default EventManagerActions;
